import { Button } from '@veneer/core'
import React from 'react'

import { UnrecoverableErrorEntry } from '@/components/shared/UnrecoverableError/types'
import { UnrecoverableErrorPageAnalytics } from '@/components/shared/UnrecoverableError/UnrecoverableErrorPage.analytics'
import { ENTRIES } from '@/constants/content-stack'
import { ErrorPrefix } from '@/constants/errors/prefix'
import type { ErrorCode } from '@/errors/classes/ErrorCode'
import { useContentStack } from '@/services/content-stack'
import { dispatchNextStage } from '@/utils/dispatch-next-stage'
import { getCommonsNorthboundAPIs } from '@foreign-clientos/dependency-manager'

type ExitButtonProps = Readonly<{ error: ErrorCode }>

export const ERROR_DESCRIPTIONS: Record<string, string> = {
  [ErrorPrefix.CMS]: 'Unable to fetch content from CMS',
  DEPENDENCY: 'Unable to render page due to missing dependency',
}
export function ExitButton({ error }: ExitButtonProps) {
  const { entry } = useContentStack<UnrecoverableErrorEntry>({
    entryParams: ENTRIES.UNRECOVERABLE_ERROR,
    ensuresEntryFulfilled: true,
  })

  const clickHandler = () => {
    const serviceId =
      getCommonsNorthboundAPIs().v1.store.state.onboarding?.sessionContext
        ?.currentServiceId

    const serviceErrorCode = `${serviceId}.${error.errorCode}`

    const errorDescription =
      ERROR_DESCRIPTIONS[error.getErrorCodeDetails().prefix!] ||
      ERROR_DESCRIPTIONS.DEPENDENCY

    UnrecoverableErrorPageAnalytics.fireExitSetupButtonClicked()
    dispatchNextStage('failure', {
      errorCode: serviceErrorCode,
      errorDescription,
    })
  }

  return (
    <Button
      data-testid="exit-setup"
      appearance="primary"
      onClick={clickHandler}
    >
      {entry.exitSetupButton}
    </Button>
  )
}
